import React, { Component } from 'react';

import { TableLayout } from '../../Menu/Stock/containers/Layout';
import SearchBar from '../Layouts/SeachBar';
import Dialog from '../../../commonModules/interface/Dialog';

import NewAlertManagement from './NewAlertManagement';
import { isEmpty } from "lodash";
import { Box, Table, TableHead, TableBody, TableRow, Grid, Button, TableCell, IconButton } from '@material-ui/core';
import PageAdmin from '../Layouts/PageAdmin';
import SearchBarAction from '../Layouts/SearchBarAction';
import { AddRounded, DeleteOutlineRounded } from '@material-ui/icons';
import DeleteDialog from '../../../commonModules/interface/DeleteDialog';
import { toast } from 'react-toastify';


class AlertManagement extends Component {
    state = { 
        new: false,
        list: [],
        deletePopup: false,
        currentAlert: {},

     }
    componentDidMount = async  () => {
        const { ALERTS } = this.props;
        if( !ALERTS ){
            await this.props.fetchAlerts()
        }
        this.filterList()
    }
    filterList = (list) => {
        if( !list ){
            if(!isEmpty(this.props.ALERTS) ){
                list = Object.keys(this.props.ALERTS)
            } else {
                list = []
            }
        }

        this.setState({
            list
        })
    }
    deleteAlert = async () => {
        this.props.deleteAlert(this.state.currentAlert)
        if(this.props.STATE.alerts.error){
            console.log("[ERROR] delete alert", this.props.STATE.alerts.error); 
            toast.error(  "Un Problème est survenu")
        } else {
            toast.success( "Alerte supprimée avec succès")
            this.setState({
                deletePopUp:false,
                currentAlert:{},
            })
        }  
    }
    render() {
        const { ALERTS } = this.props;
        console.log("[INFO], Alter Management , ALERTS");
        console.log(ALERTS)
        const { currentAlert, deletePopup } = this.state
        //TO REMOVE TO CODE DETAILS
        return (
            <PageAdmin title="Alertes">
                {this.state.new &&
                    <NewAlertManagement 
                        popupState={"overlay"} 
                        onCloseOverlay={()=> this.setState({ new: false })}
                        {...this.props}
                    />
                }
                {(deletePopup && currentAlert) &&
                    <DeleteDialog
                        title={"l'alerte " + currentAlert.alert_name}
                        handleSubmit={this.deleteAlert}
                        close={()=>this.setState({deletePopup: false, currentAlert: {}})}
                        open={true}
                    />
                //    <Dialog 
                //         title="Details"
                //         block={deletePopup}
                //         title={"Details"}
                //         close={()=> this.setState({deletePopup:false, currentAlert:""}) }
                //     >
                //         <Box>
                //             <Table>
                //                 <TableBody className="text-left">
                //                     {ALERTS[currentAlert].other && 
                //                         Object.keys(ALERTS[currentAlert].other).map((key)=>(

                //                             <TableRow key={key}>
                //                                 <TableCell>{key}</TableCell>
                //                                 <TableCell>{
                //                                     Array.isArray(ALERTS[currentAlert].other[key]) ? 
                //                                     ALERTS[currentAlert].other[key].join(' - ') :
                //                                     ALERTS[currentAlert].other[key] 
                //                                     }
                //                                 </TableCell>
                //                             </TableRow>
                //                         )) 
                //                     }
                //                 </TableBody>
                                
                //             </Table>
                //         </Box>
                //    </Dialog>
                }
                {/* <h3>ALERTES</h3> */}
                {/* <Grid container spacing={2}>
                    <Grid item sm={3} >
                        <Button 
                            variant="contained" 
                            color="secondry" 
                            onClick={() => this.setState({ new: true }) }
                        >
                            Nouveau
                        </Button>
                    </Grid>
                    <Grid item sm={9} >
                        <SearchBar list={ ALERTS } filterList={this.filterList}/>
                        </Grid>
                        
                    </Grid> */}
                <SearchBarAction list={ ALERTS } filterList={this.filterList} action={() => this.setState({ new: true }) }/>
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nom Alerte</TableCell>
                            <TableCell>Abonnement</TableCell>
                            <TableCell>Action</TableCell>
                            <TableCell>Extra Info</TableCell>
                            <TableCell>Message</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Supprimer</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ALERTS && 
                            this.state.list.map( ID => {
                                let alert = ALERTS[ID]
                                return(
                                    <TableRow key={alert.alert_id}>
                                        <TableCell>{ alert.alert_name }</TableCell>
                                        <TableCell>{ alert.subID }</TableCell>
                                        <TableCell>{ alert.alert_type }</TableCell>
                                        <TableCell>{ alert.info.startVal } - {alert.info.stopVal}</TableCell>
                                        <TableCell>{ alert.message }</TableCell>
                                        <TableCell>{ alert.status }</TableCell>
                                        <TableCell >
                                            <IconButton
                                                onClick={ () => this.setState({ currentAlert: alert, deletePopup: true }) }
                                            >
                                                <DeleteOutlineRounded color="error"/>
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </TableLayout>
            </PageAdmin>
        );
    }
}

export default AlertManagement